import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import Badges from '../homePage/Badges';
import Reviews from '../homePage/Reviews';
import Works from '../homePage/Works';
import Technologies from '../homePage/Technologies';
import { PageContent, PageContainer } from '../homePage/styled';
import FinanceServices from './FinanceServices';
import ProcessSection from './ProcessSection';

import MessageCard from '../Card/MessageCard';
import FinanceSolutions from './FinanceSolutions';
import TopPageSectionWrapper from '../TopPageSectionWrapper';
import ContactUsForm from '../ContactUsForm';

const FinanceSoftwarePage = () => {
  const { message } = useStaticQuery(query);
  return (
    <PageContainer>
      <PageContent>
        <TopPageSectionWrapper
          title="Fintech software development company"
          description="We build fintech software solutions that help clients automate financial processes, boost
          customer satisfaction, and cut costs."
        />
        <FinanceServices />
        <div className="badges-wrapper">
          <Badges />
          <Reviews />
        </div>
      </PageContent>
      <Works />
      <PageContent>
        <FinanceSolutions />
        <MessageCard
          image={message}
          title="Aim to build a top-notch fintech app? "
          subtitile="Feel free to contact us!"
          button="Contact us"
          style={{ margin: '0' }}
        />
        <ProcessSection />
        <Technologies />
        <ContactUsForm />
      </PageContent>
    </PageContainer>
  );
};

export const query = graphql`
  {
    message: file(relativePath: { eq: "images/updateDesign/message.png" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED)
      }
    }
  }
`;

export default FinanceSoftwarePage;
